import { defaultLocale, type Locale } from "@/lib/i18n";

export function getWeddingBasePath(locale: Locale): string {
  return locale === defaultLocale ? "/wedding" : `/wedding/${locale}`;
}

export function getWeddingInvitationPath(locale: Locale): string {
  return locale === defaultLocale
    ? "/wedding/invitation"
    : `/wedding/${locale}/invitation`;
}

export function getWeddingGalleryPath(locale: Locale, albumId: string): string {
  return `${getWeddingBasePath(locale)}/gallery/${albumId}`;
}
